export const Events = {

    ON_LOGIN: 'ON_LOGIN',
    ON_NAVIGATE: 'ON_NAVIGATE',

    SHOW_CAMERA: 'SHOW_CAMERA',
    HIDE_CAMERA: 'HIDE_CAMERA',

    SHOW_LOADING: 'SHOW_LOADING',
    HIDE_LOADING: 'HIDE_LOADING',

    SHOW_LOGIN: 'SHOW_LOGIN',
    HIDE_LOGIN: 'HIDE_LOGIN'
}
